import {AfterContentInit, Component, Injector, Input} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ErrorLabelConstants} from '../../constants/error-label.constants';
import {BasePageComponent} from '../../../base/components/base-page.component';
import {ClientAccountService} from '../../services/client-account.service';
import {MessageType} from '../../constants/message-type.constant';
import {CustomerModel} from '../../models/customer.model';
import {AccountModel} from '../../models/account.model';
import {SidebarService} from '../../../core/services/sidebar.service';
import {AuthService} from '../../../core/auth/auth.service';
import {TreeUnitResearchModel} from '../../models/tree-unit-research.model';
import {TreeUnitResearchFilterModel} from '../../models/tree-unit-research-filter.model';
import {TreeUnitResearchOptionsModel} from '../../models/tree-unit-research-options.model';
import {UnitModel} from '../../models/unit.model';
import {UnitService} from '../../services/unit.service';
import {FeaturesService} from "../../services/features.service";

declare var $: any;

@Component({
  selector: 'app-client-account-choice',
  templateUrl: './client-account-choice.component.html',
  styleUrls: ['./client-account-choice.component.scss']
})
export class ClientAccountChoiceComponent extends BasePageComponent implements AfterContentInit {

  @Input() parentForm: FormGroup;
  @Input() showButtons: boolean = true;

  form: FormGroup;
  formErrors: any;
  clients: Array<CustomerModel>;
  accounts: Array<AccountModel> = [];
  clientSelected: any;
  accountSelected: any;
  accountsLoading: boolean;
  tree: UnitModel;

  constructor(
    injector: Injector,
    public fb: FormBuilder,
    public router: Router,
    private clientAccountService: ClientAccountService,
    public sidebarService: SidebarService,
    private authService: AuthService,
    private unitService: UnitService,
    private featuresService: FeaturesService
  ) {
    super(injector);
    this.startPageLoading();
    this.clientAccountService.changeClienteAccount();
    this.clientAccountService.clearOnlyUnit();
    this.sidebarService.unsetSidebarActive();
  }

  pageName(): string {
    return 'ClientAccountChoiceComponent';
  }

  ngOnInitForChildren(): void {
    this.createForm();
    this.createFormErrors();
    this.getClients();
  }

  ngAfterContentInit(): void {
  }

  ngOnDestroyForChildren(): void {
  }

  getClients() {
    this.clientAccountService.getClients().subscribe((clients: Array<CustomerModel>) => {
      this.clients = clients;
      // per select bootstrap(refresh)
      setTimeout(() => {
        $('#customer').on('loaded.bs.select', () => {
        });

        $('#customer').selectpicker('refresh');
      }, 0);

      setTimeout(() => {
        $('#account').on('loaded.bs.select', () => {
        });

        $('#account').selectpicker('refresh');
      }, 0);

      // gestione in caso di prima selezione o cambio
      if (!this.clientAccountService.getCustomerToChange()) {
        console.log('non modalità cambio');
        this.manageInit();
      } else {
        console.log('modalità cambio');
        this.manageChange();
      }
    }, (error => {
      setTimeout(() => {
        $('#customer').on('loaded.bs.select', () => {
        });
        $('#customer').selectpicker('refresh');
      }, 0);
      setTimeout(() => {
        $('#account').on('loaded.bs.select', () => {
        });
        $('#account').selectpicker('refresh');
      }, 0);

      this.stopPageLoading();
    }));
  }

  manageInit() {
    if (this.clients.length === 1) {
      this.onClienteSelected(this.clients[0].customerCode);
      this.form.get('customer').disable();
    } else {
      this.stopPageLoading();
    }
  }

  manageChange() {
    this.clientAccountService.getAccounts(this.clientAccountService.getCustomerToChange().customerCode).subscribe((res: Array<AccountModel>) => {
      this.accounts = res;
      // manage customer
      setTimeout(() => {
        $('#customer').selectpicker('val', this.clientAccountService.getCustomerToChange().customerCode);
        $('#customer').selectpicker('refresh');

        $('#account').prop('disabled', false);
        $('#account').selectpicker('refresh');
      }, 0);
      this.clientSelected = this.clientAccountService.getCustomerToChange().customerCode;
      this.form.get('customer').setValue(this.clientAccountService.getCustomerToChange().customerCode);
      this.form.get('account').enable();

      // manage account
      setTimeout(() => {
        $('#account').selectpicker('val', this.clientAccountService.getAccountToChange()?.accountCode);
        $('#account').selectpicker('refresh');
      }, 0);
      this.accountSelected = this.clientAccountService.getAccountToChange()?.accountCode;
      this.form.get('account').setValue(this.clientAccountService.getAccountToChange()?.accountCode);

      this.accountsLoading = false;
      this.drawTree();
      this.stopPageLoading();
    });
  }

  createForm() {
    this.form = this.parentForm ? this.parentForm : this.fb.group({});
    this.form.addControl('customer', new FormControl('', Validators.required));
    this.form.addControl('account', new FormControl('', Validators.nullValidator));
  }

  createFormErrors(): void {
    this.formErrors = {
      customer: [
        ErrorLabelConstants.REQUIRED
      ],
      account: [],
    };
  }

  isFormInvalid(){
    return this.form.invalid;
  }

  onClienteSelected(e) {
    if (!e) {
      return;
    }
    this.tree = undefined;
    this.accountSelected = undefined;
    this.accountsLoading = true;

    for (let c of this.clients) {
      if (c.customerCode == e) {
        this.clientSelected = e;
      }
    }

    this.clientAccountService.getAccounts(e).subscribe((res: Array<AccountModel>) => {
      this.accounts = res;

      if (this.accounts.length === 1 && this.clients.length === 1) {
        this.onAccountSelected(this.accounts[0].accountCode);
        this.clientAccountService.setUserOnlyUnit(true);
        console.log('nessuna unit da selezionare');
        this.accedi();
        return;
      } else {
        setTimeout(() => {
          $('#customer').selectpicker('val', this.clientSelected);
          $('#customer').selectpicker('refresh');
        }, 0);
        this.clientAccountService.clearOnlyUnit();
        this.stopPageLoading();
      }

      this.drawTree();

      this.form.get('account').enable();

      setTimeout(() => {
        $('#account').prop('disabled', false);
        $('#account').selectpicker('val', '');
        $('#account').selectpicker('refresh');
      }, 0);
      this.accountsLoading = false;

    }, (error => {
      this.messageService.throwMessageSimple(error.messageService, MessageType.ERROR_BLOCK);
    }));

  }

  onAccountSelected(e) {
    if (!e) {
      return;
    }

    this.accountSelected = e;

    this.drawTree();
  }

  drawTree() {
    return this.unitService.getUnitTree(this.buildTreeModel()).subscribe((res: UnitModel) => {
        console.log(res);
        this.tree = res;
      },
      (error => {
        this.tree = undefined;
      }));
  }

  buildTreeModel(): TreeUnitResearchModel {
    let model = new TreeUnitResearchModel();
    model.filter = new TreeUnitResearchFilterModel(this.accountSelected, this.clientSelected);
    model.options = new TreeUnitResearchOptionsModel(false, true);
    return model;
  }

  accedi() {
    if (this.clientSelected) {
      let customer: CustomerModel;
      for (let c of this.clients) {
        if (c.customerCode === this.clientSelected) {
          customer = c;
        }
      }
      this.clientAccountService.setCustomer(customer);

      if (this.accountSelected) {
        let account: AccountModel;
        for (let a of this.accounts) {
          if (a.accountCode === this.accountSelected) {
            account = a;
          }
        }
        this.clientAccountService.setAccount(account);
      } else {
        this.clientAccountService.setAccount(null);
      }
      this.clientAccountService.clearCustomerAccountToChange();
      this.router.navigate(['dashboard']);
    } else {
      this.messageService.throwMessageSimple('Nessun cliente selezionato', MessageType.ERROR_BLOCK);
    }
  }

  logout() {
    this.authService.logout();
  }

  resetAccount() {
    this.clientAccountService.setAccount(null);
    this.form.get('account').setValue(undefined);
    this.accountSelected = undefined;
    setTimeout(() => {
      $('#account').prop('disabled', false);
      $('#account').selectpicker('val', '');
      $('#account').selectpicker('refresh');
    }, 0);
  }
}
